module.exports = __webpack_public_path__ + "img/38868-019.96350db2.jpg";